import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSelectedTabstate } from "../../action/index.js"
import { handleCommonModal } from "../../action/quote_order/leadcustomer.action.js"
import { handleSaveLatter } from "../../action/quote_order/quote.action.js";
import { CheckCaptureModalImage } from "../../action/extra_options/orderExtras.action.js";



class CallForPricing extends Component {

  render() {
    let dealer_discount =
      this.props.const_var.post_data.building != undefined &&
      this.props.const_var.post_data.building.down_payment_discount_total !=
        undefined &&
      this.props.const_var.post_data.building.down_payment_discount_total !=
        0 &&
      this.props.const_var.BuildingPriceArrar["down_payment_discount_total"] !=
        0;
    return (<>
        <label className="nav-info-name">{this.props.const_var.hide_price_calculation == 1 ? 'Contact for pricing' : 'Contact Info'}</label>
        <label className="nav-info-value contact-info">
          <a href={"tel:" + this.props.const_var.crmSetting.phone_number} className='contact-item'>
            <span className="icon"><i className='icon-phone-2'></i></span>
            {
              (window.innerWidth>992 && window.innerWidth<=1024 && dealer_discount) ?
              <span className='text'>Call</span>
              :
              <span className="text">{(window.innerWidth>992 && window.innerWidth<=1600 && !(this.props.const_var.crmSetting.is_module_name === "inventory" || (this.props.const_var.isPublicEdit==true && this.props.const_var.crmSetting.is_quote_Edit==true || this.props.const_var.isPublicEdit==true))) && this.props.const_var.loginSession ? 'Call' : this.props.const_var.crmSetting.phone_number}</span>
            }
          </a>
          <a href={"mailto:" + this.props.const_var.crmSetting.email} className='contact-item'>
            <span className="icon"><i className='icon-email-2'></i></span>
            {
               (window.innerWidth>992 && window.innerWidth<=1024 && dealer_discount) ?
               <span className="text">Email</span>
               :
               <span className="text">{(window.innerWidth>992 && window.innerWidth<=1600 && !(this.props.const_var.crmSetting.is_module_name === "inventory" || (this.props.const_var.isPublicEdit==true && this.props.const_var.crmSetting.is_quote_Edit==true || this.props.const_var.isPublicEdit==true))) && this.props.const_var.loginSession ? 'Email': 'Email us'}</span>
            }
          </a>
        </label>        
    </>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.loginReducer, ...state.leadcustomerReducer }
}
const mapDispatchToProps = {
  handleCommonModal,
  getSelectedTabstate,
  handleSaveLatter,
  CheckCaptureModalImage
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)
  (CallForPricing)